import React from "react";
import Welcome from "../../components/welcome/Welcome";
import Contactus from "../../components/contactus/Contactus";
import Generalservices from "../../components/generalservices/Generalservices";
import Hardware from "../../components/hardwares/Hardware";
import Newservices from "../../components/newservices/Newservices";
import Patners from "../../components/ourpatners/Patners";
import Quicklinks from "../../components/quicklinks/Quicklinks";
import Screentwo from "../../components/screen/Screentwo";
import Flashdeals from "../../components/flashdeals/Flashdeals";

export default function Homepage() {
  return (
    <div className="homepage">
      <Screentwo />
      <Quicklinks />
      <Newservices />
      <Welcome />
      <Generalservices />
      <Flashdeals />
      <Hardware />
      <Patners />
      <Contactus />
    </div>
  );
}
